<template>
	<div class="md-layout md-gutter">
		<div class="md-layout-item md-size-66">
			<form ref="password_form" @submit.prevent="updateContact">
				<md-card>
					<md-card-header class="md-card-header-icon md-card-header-blue">
						<div class="card-icon">
							<font-awesome-icon class="md-icon" :icon="['fa', 'pen']" />
						</div>
						<h4 class="title">Modification d'un contact</h4>
					</md-card-header>
					<md-card-content>
						<div class="md-layout md-gutter">
							<div class="md-layout-item">
                                <md-radio v-model="contact.gender" name="gender" value="Monsieur" required>Monsieur</md-radio>
                                <md-radio v-model="contact.gender" name="gender" value="Madame" required>Madame</md-radio>
							</div>
						</div>
						<div class="md-layout md-gutter">
							<div class="md-layout-item md-size-50">
								<md-field class="md-invalid">
									<label>Nom</label>
									<md-input v-model="contact.last_name" required type="text"></md-input>
									<validation-error :errors="apiValidationErrors.last_name" />
								</md-field>
							</div>
							<div class="md-layout-item md-size-50">
								<md-field class="md-invalid">
									<label>Prénom</label>
									<md-input v-model="contact.first_name" required type="text"></md-input>
									<validation-error :errors="apiValidationErrors.first_name" />
								</md-field>
							</div>
						</div>
						<div class="md-layout md-gutter mt-2">
							<div class="md-layout-item md-size-33">
								<md-field class="md-invalid">
									<label>Téléphone</label>
									<md-input v-model="contact.phone" type="text"></md-input>
									<validation-error :errors="apiValidationErrors.phone" />
								</md-field>
							</div>
							<div class="md-layout-item md-size-33">
								<md-field class="md-invalid">
									<label>Portable</label>
									<md-input v-model="contact.mobile" type="text"></md-input>
									<validation-error :errors="apiValidationErrors.mobile" />
								</md-field>
							</div>
							<div class="md-layout-item md-size-33">
								<md-field class="md-invalid">
									<label>Fax / Numéro perso</label>
									<md-input v-model="contact.fax" type="text"></md-input>
									<validation-error :errors="apiValidationErrors.fax" />
								</md-field>
							</div>
						</div>
						<div class="md-layout md-gutter mt-2">
							<div class="md-layout-item md-size-100">
								<md-field class="md-invalid">
									<label>Email</label>
									<md-input v-model="contact.email" required type="text"></md-input>
									<validation-error :errors="apiValidationErrors.email" />
								</md-field>
							</div>
						</div>
						<div class="md-layout md-gutter mt-2">
							<div class="md-layout-item md-size-100">
								<md-field class="md-invalid">
									<label>Fonction</label>
									<md-input v-model="contact.role" required type="text"></md-input>
									<validation-error :errors="apiValidationErrors.role" />
								</md-field>
							</div>
						</div>
					</md-card-content>
					<md-card-actions md-alignment="left">
						<md-button type="submit" class="md-success">
							Enregistrer
						</md-button>
						<md-button class="md-warning"
							@click="goBack">
							Retour
						</md-button>
					</md-card-actions>
				</md-card>
			</form>
		</div>
	</div>
</template>

<script>
// Components
import { ValidationError } from "@/components";

// Mixins
import formMixin from "@/mixins/form-mixin";

export default {
	name: "ClientContactEdit",
	components: { ValidationError },
	mixins: [formMixin],
	data() {
		return {
			contact: {}
		}
	},
	methods: {
		async updateContact() {
			let contact = {
				...this.contact,
				last_name: this.contact.last_name.toUpperCase(),
				role: this.contact.role.toUpperCase()
			}
			try {
				this.resetApiValidation()
				await this.$store.dispatch("contacts/updateContact", contact)
				await this.$store.dispatch("alerts/success","Contact modifié");
				this.goBack()
			} catch (e) {
				this.setApiValidation(e.response.data.errors)
			}
		},
        async getContactDetails() {
            let { data } = await this.$store.dispatch('contacts/getContactDetails', this.$route.params.idContact)
            this.contact = data
        },
		goBack() {
			this.$router.go(-1)
		}
	},
	mounted() {
		this.getContactDetails()
	}
}
</script>

<style scoped>

</style>
